class DropdownLegendHandler {
  constructor() {
    this.syncQueued = false;
    this.hasUserInteracted = false;
    this.initialVariantStabilized = false;
    this.initialize();
  }

  getSelectedSizeInput() {
    const directSizeInput = document.querySelector('.product-options__option-group--size input[type="radio"]:checked');
    if (directSizeInput) return directSizeInput;

    const sizeSelectFieldset = Array.from(document.querySelectorAll('.selectOption[select-product-option]')).find(fieldset => {
      const raw = fieldset.getAttribute('select-product-option');
      if (!raw) return false;
      try {
        const parsed = JSON.parse(raw);
        return parsed?.name?.toLowerCase() === 'size';
      } catch (_e) {
        return false;
      }
    });

    return sizeSelectFieldset
      ? sizeSelectFieldset.querySelector('input[type="radio"]:checked')
      : null;
  }

  getUrlVariantId() {
    const rawVariant = window.__INITIAL_VARIANT_FROM_URL || new URLSearchParams(window.location.search).get('variant');
    const parsed = rawVariant ? parseInt(rawVariant, 10) : null;
    return Number.isFinite(parsed) ? parsed : null;
  }

  initialize() {

    this.setupEventListeners();
    this.scheduleSelectOptionTextSync();

    setTimeout(() => {

      this.updateDropdownLegends();
      this.scheduleSelectOptionTextSync();

      setTimeout(() => this.updateDropdownLegends(), 500);
      setTimeout(() => this.updateDropdownLegends(), 1000);
      setTimeout(() => this.scheduleSelectOptionTextSync(), 500);
      setTimeout(() => this.scheduleSelectOptionTextSync(), 1000);

      setTimeout(() => this.validateInitialState(), 200);
      setTimeout(() => this.validateInitialState(), 1000);
    }, 300); // Wait for variant availability to finish
  }

  updateDropdownLegends() {

    const dropdownGroups = document.querySelectorAll('.product-options__option-group[data-option-type="dropdown"]');

    dropdownGroups.forEach(group => {
      this.updateGroupLegend(group);
    });
  }

  updateGroupLegend(group) {

    const selectedInput = group.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked');

    if (!selectedInput) return;

    const displayValue = this.getDisplayValue(selectedInput);

    this.updateLegendElements(group, displayValue);
    this.syncSelectOptionText(group);
  }

  getDisplayValue(selectedInput) {

    const optionElement = selectedInput.closest('.selectOption__option, .product-options__option-value');
    if (optionElement) {
      const textElement = optionElement.querySelector('.selectOption__value, .product-options__option-label');
      if (textElement) {
        return textElement.textContent.trim();
      }
    }

    return selectedInput.value;
  }

  updateLegendElements(group, value) {

    const legendValue = group.querySelector('.product-options__option-group-legend-value');
    if (legendValue) {
      legendValue.textContent = value;
    }

    const variantSelectedOptions = group.querySelectorAll('[variant-selected-option]');
    variantSelectedOptions.forEach(element => {
      element.textContent = value;
    });

    const dropdownButton = group.querySelector('.selectOption__select--text');
    if (dropdownButton) {
      dropdownButton.textContent = value;
    }
  }

  scheduleSelectOptionTextSync() {
    if (this.syncQueued) return;
    this.syncQueued = true;

    requestAnimationFrame(() => {
      this.syncQueued = false;
      this.syncSelectOptionText();
    });
  }

  syncSelectOptionText(scope = document) {
    const selectOptions = scope.querySelectorAll('.selectOption');

    selectOptions.forEach(selectOption => {
      const textEl = selectOption.querySelector('.selectOption__select--text');
      const checkedInput = selectOption.querySelector('input[type="radio"]:checked');
      if (!textEl || !checkedInput) return;

      const trigger = selectOption.querySelector('.selectOption__select');
      const isOpen = selectOption.classList.contains('selectOption--open') ||
        trigger?.getAttribute('aria-expanded') === 'true';
      if (isOpen) return;

      const label = checkedInput.closest('label');
      const valueEl = label ? label.querySelector('.selectOption__value') : null;
      const nextText = (valueEl ? valueEl.textContent : checkedInput.value || '').trim();
      if (!nextText) return;

      if (textEl.textContent !== nextText) {
        textEl.textContent = nextText;
      }
      if (textEl.style.opacity !== '1') {
        textEl.style.opacity = '1';
      }
    });
  }

  autoSelectColorBasedOnSize() {
    const colorGroup = document.querySelector('.product-options__option-group--color');
    if (!colorGroup) return;
    if (!colorGroup.querySelector('input[type="radio"]:checked')) return;

    // Do NOT auto-switch to another color when combo is unavailable
    // Keep user's selection; variant-picker will show Unavailable for add-to-cart
    setTimeout(() => {
      this.updateColorDisplayText();
      this.updateVariantIdInput();
    }, 50);
  }

  autoSelectSizeBasedOnColor() {
    const sizeGroup = document.querySelector('.product-options__option-group--size');
    if (!sizeGroup) return;
    if (!sizeGroup.querySelector('input[type="radio"]:checked')) return;

    // Do NOT auto-switch to another size when combo is unavailable
    // Keep user's selection; variant-picker will show Unavailable for add-to-cart
    setTimeout(() => {
      this.updateSizeDisplayText();
      this.updateVariantIdInput();
    }, 50);
  }

  handleNoColorSelected() {
    const colorGroup = document.querySelector('.product-options__option-group--color');
    if (!colorGroup) return;

    const selectedColorInput = colorGroup.querySelector('input[type="radio"]:checked');
    if (selectedColorInput) return;

    const colorInputs = colorGroup.querySelectorAll('input[type="radio"]');
    for (let input of colorInputs) {
      if (!input.disabled && input.style.display !== 'none') {
        input.checked = true;
        input.click();
        break;
      }
    }
  }

  validateInitialState() {
    if (window.variantAvailability && window.variantAvailability.isProcessing) {
      setTimeout(() => this.validateInitialState(), 100);
      return;
    }

    this.handleNoColorSelected();

    this.autoSelectColorBasedOnSize();

    setTimeout(() => {
      this.autoSelectSizeBasedOnColor();
    }, 150);

    setTimeout(() => {
      const sizeInput = this.getSelectedSizeInput();
      const colorInput = document.querySelector('.product-options__option-group--color input[type="radio"]:checked');
      console.log('[DropdownLegend][ValidateInitialState] selected size/color:', {
        size: sizeInput?.value || null,
        color: colorInput?.value || null,
        hasUserInteracted: this.hasUserInteracted,
        initialVariantStabilized: this.initialVariantStabilized
      });
      this.updateColorDisplayText();
      this.updateSizeDisplayText();
      this.updateVariantIdInput();
      this.scheduleSelectOptionTextSync();
    }, 200);
  }

  updateColorDisplayText() {
    const colorGroup = document.querySelector('.product-options__option-group--color');
    if (!colorGroup) return;

    const selectedColorInput = colorGroup.querySelector('input[type="radio"]:checked');
    if (!selectedColorInput) return;

    const selectedColor = selectedColorInput.value;

    const variantSelectedOptions = colorGroup.querySelectorAll('[variant-selected-option]');
    variantSelectedOptions.forEach(element => {
      element.textContent = selectedColor;
    });

    const legendValue = colorGroup.querySelector('.product-options__option-group-legend-value');
    if (legendValue) {
      legendValue.textContent = selectedColor;
    }

    const displayElements = colorGroup.querySelectorAll('.product-options__option-group-legend-value, [variant-selected-option]');
    displayElements.forEach(element => {
      element.textContent = selectedColor;
    });

    this.scheduleSelectOptionTextSync();
  }

  updateSizeDisplayText() {
    const sizeGroup = document.querySelector('.product-options__option-group--size');
    if (!sizeGroup) return;

    const selectedSizeInput = sizeGroup.querySelector('input[type="radio"]:checked');
    if (!selectedSizeInput) return;

    const selectedSize = selectedSizeInput.value;

    const variantSelectedOptions = sizeGroup.querySelectorAll('[variant-selected-option]');
    variantSelectedOptions.forEach(element => {
      element.textContent = selectedSize;
    });

    const legendValue = sizeGroup.querySelector('.product-options__option-group-legend-value');
    if (legendValue) {
      legendValue.textContent = selectedSize;
    }

    const dropdownButton = sizeGroup.querySelector('.selectOption__select--text');
    if (dropdownButton) {
      dropdownButton.textContent = selectedSize;
    }

    const displayElements = sizeGroup.querySelectorAll('.product-options__option-group-legend-value, [variant-selected-option], .selectOption__select--text');
    displayElements.forEach(element => {
      element.textContent = selectedSize;
    });

    this.scheduleSelectOptionTextSync();
  }

  updateVariantIdInput() {
    const variantDataScript = document.getElementById('product-options-variant-data');
    if (!variantDataScript) return;

    try {
      const productData = JSON.parse(variantDataScript.textContent);

      const colorGroup = document.querySelector('.product-options__option-group--color');
      if (!colorGroup) return;

      const selectedColorInput = colorGroup.querySelector('input[type="radio"]:checked');
      const selectedSizeInput = this.getSelectedSizeInput();

      if (!selectedColorInput || !selectedSizeInput) return;

      const selectedColor = selectedColorInput.value;
      const selectedSize = selectedSizeInput.value;
      const urlVariantId = this.getUrlVariantId();

      // Use option indices - options can be Color,Size or Size,Color
      const colorIndex = productData.options.findIndex(opt => opt.toLowerCase() === 'color');
      const sizeIndex = productData.options.findIndex(opt => opt.toLowerCase() === 'size');
      if (colorIndex === -1 || sizeIndex === -1) return;

      const correctVariant = productData.variants.find(variant => {
        const vColor = (variant[`option${colorIndex + 1}`] || '').toString().trim();
        const vSize = (variant[`option${sizeIndex + 1}`] || '').toString().trim();
        return vColor === selectedColor && vSize === selectedSize;
      });
      console.log('[DropdownLegend][VariantIdSync] URL Variant:', urlVariantId, 'Matched Variant:', correctVariant);

      if (correctVariant) {

        const variantIndex = productData.variants.findIndex(v => v.id === correctVariant.id);
        if (variantIndex !== -1) {
          const metafields = productData.variants_metafields[variantIndex];
          const isAvailable = !(
            (metafields && metafields.custom && metafields.custom.availability === false) ||
            (metafields && metafields.availability === false)
          );

          if (isAvailable) {
            const variantIdInput = document.querySelector('input[name="id"], select[name="id"]');
            if (variantIdInput) {
              if (urlVariantId && !this.initialVariantStabilized && !this.hasUserInteracted) {
                console.log('[DropdownLegend][VariantIdSync] Guard active - skipping bootstrap override', {
                  before: variantIdInput.value,
                  attempted: correctVariant.id,
                  urlVariantId
                });
                return;
              }
              console.log('[DropdownLegend][VariantIdSync] Before override:', variantIdInput.value, 'After override:', correctVariant.id);
              variantIdInput.value = correctVariant.id;

              variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
            }

            const variantSelects = document.querySelectorAll('select[name="id"]');
            variantSelects.forEach(select => {
              const option = select.querySelector(`option[value="${correctVariant.id}"]`);
              if (option) {
                select.value = correctVariant.id;
              }
            });
          }
        }
      } else {
      }
    } catch (error) {
      console.error('[Update Variant ID] Error:', error);
    }
  }

  setupEventListeners() {
    document.addEventListener('change', (event) => {
      const input = event.target;
      if (input.matches('input[type="radio"], input[type="checkbox"]')) {
        this.hasUserInteracted = true;
        const dropdownGroup = input.closest('.product-options__option-group[data-option-type="dropdown"]');
        if (dropdownGroup) {
          this.updateGroupLegend(dropdownGroup);
        }

        const sizeGroup = input.closest('.product-options__option-group--size');
        if (sizeGroup && input.checked) {
          this.updateSizeDisplayText();

          setTimeout(() => {
            this.updateVariantIdInput();
          }, 50);

          setTimeout(() => {
            this.autoSelectColorBasedOnSize();
          }, 100);
        }

        const colorGroup = input.closest('.product-options__option-group--color');
        if (colorGroup && input.checked) {
          this.updateColorDisplayText();

          setTimeout(() => {
            this.updateVariantIdInput();
          }, 50);

          // small delay
          setTimeout(() => {
            this.autoSelectSizeBasedOnColor();
          }, 100);
        }

        this.scheduleSelectOptionTextSync();
      }
    });

    document.addEventListener('variant:initial-stabilized', () => {
      this.initialVariantStabilized = true;
    });

    document.addEventListener('variant:initial-selection', (event) => {
      if (event.detail && event.detail.variant) {
        setTimeout(() => {
          this.updateDropdownLegends();
          this.validateInitialState();
          this.scheduleSelectOptionTextSync();
        }, 100);
      }
    });

    document.addEventListener('variant:availability-updated', () => {
      setTimeout(() => {
        this.updateDropdownLegends();
        this.validateInitialState();
        this.scheduleSelectOptionTextSync();
      }, 100);
    });

    document.addEventListener('variant:changed', () => {
      setTimeout(() => {
        this.updateDropdownLegends();
        this.validateInitialState();
        this.scheduleSelectOptionTextSync();
      }, 200);
    });

    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(() => {
        this.updateDropdownLegends();
        this.validateInitialState();
        this.scheduleSelectOptionTextSync();
      }, 100);
    });

    // Listen for window load
    window.addEventListener('load', () => {
      setTimeout(() => {
        this.updateDropdownLegends();
        this.validateInitialState();
        this.scheduleSelectOptionTextSync();
      }, 100);
    });

    setInterval(() => {
      this.updateDropdownLegends();
      this.validateInitialState();
      this.scheduleSelectOptionTextSync();
    }, 2000);
  }
}

window.dropdownLegendHandler = new DropdownLegendHandler();

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => window.dropdownLegendHandler);
} else {
  window.dropdownLegendHandler;
} 